<div style="display: block">
    <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [chartType]="barChartType" [legend]="barChartLegend"></canvas>
</div>